import { DoorConfiguration as contex } from '../DoorConfiguration';
import copyObject, * as helper from './Shared';
import store from '@/store/index';
import { Characteristic, ValueDefinition } from '../types';

// KTU_MM_SCHL_Q_BS
export const schlagleisteHorizontalOpeningSide = (): ValueDefinition => {

    let lltNumber: string = '0';

    const doorModel = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);
    const doorLeafSurfaceOpeningSide = helper.GetDependencyValueCode('KTU_MM_TOBERFL_BS', contex.DoorLeafSurface);
    const zierlesitenVariantBandSeite = helper.GetDependencyValueCode('KTU_MM_ZIERLEISTENVAR_BS', contex.Functions);
    const zierleistenArt = helper.GetDependencyValueCode('KTU_MM_ZIERLEISTENART', contex.Functions);
    const schlagleisteHorizontalBandSeite = helper.GetDependencyValueCode('CUST_MM_SCHLAGL_ANZ_W_BS', contex.Functions);

    const hasZierleistenOpeningSide = zierlesitenVariantBandSeite !== 'ZV0' ? true : false;



    switch (doorModel) {
        case 'CERT':
            switch (doorLeafSurfaceOpeningSide) {
                case 'DEKOR':
                case 'FURNIER':
                    if (hasZierleistenOpeningSide === false) {
                        switch (schlagleisteHorizontalBandSeite) {
                            case '1':
                                lltNumber = 'LLT100081';
                                break;
                            case '2':
                                lltNumber = 'LLT100082';
                                break;
                        }
                    } else {
                        switch (zierleistenArt) {
                            case '5':
                            case '6':
                                switch (schlagleisteHorizontalBandSeite) {
                                    case '1':
                                        lltNumber = 'LLT100081';
                                        break;
                                    case '2':
                                        lltNumber = 'LLT100082';
                                        break;
                                }
                                break;
                            case '1':
                            case '2':
                                switch (schlagleisteHorizontalBandSeite) {
                                    case '1':
                                        lltNumber = 'LLT100083';
                                        break;
                                    case '2':
                                        lltNumber = 'LLT100084';
                                        break;
                                }
                                break;
                            default:
                                switch (schlagleisteHorizontalBandSeite) {
                                    case '1':
                                        lltNumber = 'LLT100083';
                                        break;
                                    case '2':
                                        lltNumber = 'LLT100084';
                                        break;
                                }
                                break;
                        }
                    }
                    break;
                case 'LACKIERUNG':
                    if (hasZierleistenOpeningSide === false) {
                        switch (schlagleisteHorizontalBandSeite) {
                            case '1':
                                lltNumber = 'LLT100085';
                                break;
                            case '2':
                                lltNumber = 'LLT100086';
                                break;
                        }
                    } else {
                        switch (zierleistenArt) {
                            case '5':
                            case '6':
                                switch (schlagleisteHorizontalBandSeite) {
                                    case '1':
                                        lltNumber = 'LLT100085';
                                        break;
                                    case '2':
                                        lltNumber = 'LLT100086';
                                        break;
                                }
                                break;
                            case '1':
                            case '2':
                                switch (schlagleisteHorizontalBandSeite) {
                                    case '1':
                                        lltNumber = 'LLT100087';
                                        break;
                                    case '2':
                                        lltNumber = 'LLT100088';
                                        break;
                                }
                                break;
                            default:
                                switch (schlagleisteHorizontalBandSeite) {
                                    case '1':
                                        lltNumber = 'LLT100087';
                                        break;
                                    case '2':
                                        lltNumber = 'LLT100088';
                                        break;
                                }
                                break;
                        }
                    }
                    break;
            }
            break;
        case 'BERT':
        case 'VERT':
            switch (doorLeafSurfaceOpeningSide) {
                case 'DEKOR':
                case 'FURNIER':
                    if (hasZierleistenOpeningSide === false) {
                        switch (schlagleisteHorizontalBandSeite) {
                            case '1':
                                lltNumber = 'LLT100081';
                                break;
                            case '2':
                                lltNumber = 'LLT100082';
                                break;
                        }
                    } else {
                        switch (zierleistenArt) {
                            case '5':
                            case '6':
                                switch (schlagleisteHorizontalBandSeite) {
                                    case '1':
                                        lltNumber = 'LLT100081';
                                        break;
                                    case '2':
                                        lltNumber = 'LLT100082';
                                        break;
                                }
                                break;
                            case '1':
                            case '2':
                                switch (schlagleisteHorizontalBandSeite) {
                                    case '1':
                                        lltNumber = 'LLT100083';
                                        break;
                                    case '2':
                                        lltNumber = 'LLT100084';
                                        break;
                                }
                                break;
                            default:
                                switch (schlagleisteHorizontalBandSeite) {
                                    case '1':
                                        lltNumber = 'LLT100083';
                                        break;
                                    case '2':
                                        lltNumber = 'LLT100084';
                                        break;
                                }
                                break;
                        }
                    }
                    break;
                case 'LACKIERUNG':
                    if (hasZierleistenOpeningSide === false) {
                        switch (schlagleisteHorizontalBandSeite) {
                            case '1':
                                lltNumber = 'LLT100085';
                                break;
                            case '2':
                                lltNumber = 'LLT100086';
                                break;
                        }
                    } else {
                        switch (zierleistenArt) {
                            case '5':
                            case '6':
                                switch (schlagleisteHorizontalBandSeite) {
                                    case '1':
                                        lltNumber = 'LLT100085';
                                        break;
                                    case '2':
                                        lltNumber = 'LLT100086';
                                        break;
                                }
                                break;
                            case '1':
                            case '2':
                                switch (schlagleisteHorizontalBandSeite) {
                                    case '1':
                                        lltNumber = 'LLT100087';
                                        break;
                                    case '2':
                                        lltNumber = 'LLT100088';
                                        break;
                                }
                                break;
                            default:
                                switch (schlagleisteHorizontalBandSeite) {
                                    case '1':
                                        lltNumber = 'LLT100087';
                                        break;
                                    case '2':
                                        lltNumber = 'LLT100088';
                                        break;
                                }
                                break;
                        }
                    }
                    break;
            }
            break;
    }

    let characteristic: any;
    let value: ValueDefinition;
    const char = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_SCHL_Q_BS')[0];
    characteristic = copyObject(char);
    value = characteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return value;
};

// KTU_MM_SCHL_Q_GBS
export const schlagleisteHorizontalCounterOpeningSide = (): ValueDefinition => {

    let lltNumber: string = '0';

    const doorModel = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);
    const doorLeafSurfaceCounterOpeningSide = helper.GetDependencyValueCode('KTU_MM_TOBERFL_GBS', contex.DoorLeafSurface);
    const zierlesitenVariantGegenbandseite = helper.GetDependencyValueCode('KTU_MM_ZIERLEISTENVAR_GBS', contex.Functions);
    const zierleistenArt = helper.GetDependencyValueCode('KTU_MM_ZIERLEISTENART', contex.Functions);
    const schlagleisteHorizontalGegenBandSeite = helper.GetDependencyValueCode('CUST_MM_SCHLAGL_ANZ_W_GBS', contex.Functions);
    const doorWings = helper.GetDependencyValueCode('KTU_MM_OEFFNUNGSART', contex.ModelSelection);
    const resistanceClass = helper.GetDependencyValueCode('KTU_MM_FUNKTION_RC', contex.ModelSelection);

    const hasZierleistenCounterOpeningSide = zierlesitenVariantGegenbandseite !== 'ZV0' ? true : false;



    switch (doorModel) {
        case 'CERT':
            switch (doorLeafSurfaceCounterOpeningSide) {
                case 'DEKOR':
                case 'FURNIER':
                    switch (doorWings) {
                        case 'D1':
                            if (hasZierleistenCounterOpeningSide === false) {
                                switch (schlagleisteHorizontalGegenBandSeite) {
                                    case '1':
                                        lltNumber = 'LLT100081';
                                        break;
                                    case '2':
                                        lltNumber = 'LLT100082';
                                        break;
                                }
                            } else {
                                switch (zierleistenArt) {
                                    case '5':
                                    case '6':
                                        switch (schlagleisteHorizontalGegenBandSeite) {
                                            case '1':
                                                lltNumber = 'LLT100081';
                                                break;
                                            case '2':
                                                lltNumber = 'LLT100082';
                                                break;
                                        }
                                        break;
                                    case '1':
                                    case '2':
                                        switch (schlagleisteHorizontalGegenBandSeite) {
                                            case '1':
                                                lltNumber = 'LLT100083';
                                                break;
                                            case '2':
                                                lltNumber = 'LLT100084';
                                                break;
                                        }
                                        break;
                                    default:
                                        switch (schlagleisteHorizontalGegenBandSeite) {
                                            case '1':
                                                lltNumber = 'LLT100083';
                                                break;
                                            case '2':
                                                lltNumber = 'LLT100084';
                                                break;
                                        }
                                        break;
                                }
                            }
                            break;
                        case 'D2':
                            if (hasZierleistenCounterOpeningSide === false) {
                                switch (schlagleisteHorizontalGegenBandSeite) {
                                    case '1':
                                    case '2':
                                        lltNumber = 'LLT100077';
                                        break;
                                }
                            } else {
                                switch (zierleistenArt) {
                                    case '5':
                                    case '6':
                                        switch (schlagleisteHorizontalGegenBandSeite) {
                                            case '1':
                                            case '2':
                                                lltNumber = 'LLT100077';
                                                break;
                                        }
                                        break;
                                    case '1':
                                    case '2':
                                        switch (schlagleisteHorizontalGegenBandSeite) {
                                            case '1':
                                            case '2':
                                                lltNumber = 'LLT100078';
                                                break;
                                        }
                                        break;
                                    default:
                                        switch (schlagleisteHorizontalGegenBandSeite) {
                                            case '1':
                                            case '2':
                                                lltNumber = 'LLT100078';
                                                break;
                                        }
                                        break;
                                }
                            }
                            break;
                    }
                    break;
                case 'LACKIERUNG':
                    switch (doorWings) {
                        case 'D1':
                            if (hasZierleistenCounterOpeningSide === false) {
                                switch (schlagleisteHorizontalGegenBandSeite) {
                                    case '1':
                                        lltNumber = 'LLT100085';
                                        break;
                                    case '2':
                                        lltNumber = 'LLT100086';
                                        break;
                                }
                            } else {
                                switch (zierleistenArt) {
                                    case '5':
                                    case '6':
                                        switch (schlagleisteHorizontalGegenBandSeite) {
                                            case '1':
                                                lltNumber = 'LLT100085';
                                                break;
                                            case '2':
                                                lltNumber = 'LLT100086';
                                                break;
                                        }
                                        break;
                                    case '1':
                                    case '2':
                                        switch (schlagleisteHorizontalGegenBandSeite) {
                                            case '1':
                                                lltNumber = 'LLT100087';
                                                break;
                                            case '2':
                                                lltNumber = 'LLT100088';
                                                break;
                                        }
                                        break;
                                    default:
                                        switch (schlagleisteHorizontalGegenBandSeite) {
                                            case '1':
                                                lltNumber = 'LLT100087';
                                                break;
                                            case '2':
                                                lltNumber = 'LLT100088';
                                                break;
                                        }
                                        break;
                                }
                            }
                            break;
                        case 'D2':
                            if (hasZierleistenCounterOpeningSide === false) {
                                switch (schlagleisteHorizontalGegenBandSeite) {
                                    case '1':
                                    case '2':
                                        lltNumber = 'LLT100079';
                                        break;
                                }
                            } else {
                                switch (zierleistenArt) {
                                    case '5':
                                    case '6':
                                        switch (schlagleisteHorizontalGegenBandSeite) {
                                            case '1':
                                            case '2':
                                                lltNumber = 'LLT100079';
                                                break;
                                        }
                                        break;
                                    case '1':
                                    case '2':
                                        switch (schlagleisteHorizontalGegenBandSeite) {
                                            case '1':
                                            case '2':
                                                lltNumber = 'LLT100080';
                                                break;
                                        }
                                        break;
                                    default:
                                        switch (schlagleisteHorizontalGegenBandSeite) {
                                            case '1':
                                            case '2':
                                                lltNumber = 'LLT100080';
                                                break;
                                        }
                                        break;
                                }
                            }
                            break;
                    }
                    break;
            }
            break;
        case 'BERT':
        case 'VERT':
            switch (doorLeafSurfaceCounterOpeningSide) {
                case 'DEKOR':
                case 'FURNIER':
                    switch (doorWings) {
                        case 'D1':
                            if (hasZierleistenCounterOpeningSide === false) {
                                switch (schlagleisteHorizontalGegenBandSeite) {
                                    case '1':
                                        lltNumber = 'LLT100081';
                                        break;
                                    case '2':
                                        lltNumber = 'LLT100082';
                                        break;
                                }
                            } else {
                                switch (zierleistenArt) {
                                    case '5':
                                    case '6':
                                        switch (schlagleisteHorizontalGegenBandSeite) {
                                            case '1':
                                                lltNumber = 'LLT100081';
                                                break;
                                            case '2':
                                                lltNumber = 'LLT100082';
                                                break;
                                        }
                                        break;
                                    case '1':
                                    case '2':
                                        switch (schlagleisteHorizontalGegenBandSeite) {
                                            case '1':
                                                lltNumber = 'LLT100083';
                                                break;
                                            case '2':
                                                lltNumber = 'LLT100084';
                                                break;
                                        }
                                        break;
                                    default:
                                        switch (schlagleisteHorizontalGegenBandSeite) {
                                            case '1':
                                                lltNumber = 'LLT100083';
                                                break;
                                            case '2':
                                                lltNumber = 'LLT100084';
                                                break;
                                        }
                                        break;
                                }
                            }
                            break;
                        case 'D2':
                            switch (resistanceClass) {
                                case '2':
                                case '3':
                                    if (hasZierleistenCounterOpeningSide === false) {
                                        switch (schlagleisteHorizontalGegenBandSeite) {
                                            case '1':
                                            case '2':
                                                lltNumber = 'LLT100077';
                                                break;
                                        }
                                    } else {
                                        switch (zierleistenArt) {
                                            case '5':
                                            case '6':
                                                switch (schlagleisteHorizontalGegenBandSeite) {
                                                    case '1':
                                                    case '2':
                                                        lltNumber = 'LLT100077';
                                                        break;
                                                }
                                                break;
                                            case '1':
                                            case '2':
                                                switch (schlagleisteHorizontalGegenBandSeite) {
                                                    case '1':
                                                    case '2':
                                                        lltNumber = 'LLT100078';
                                                        break;
                                                }
                                                break;
                                            default:
                                                switch (schlagleisteHorizontalGegenBandSeite) {
                                                    case '1':
                                                    case '2':
                                                        lltNumber = 'LLT100078';
                                                        break;
                                                }
                                                break;
                                        }
                                    }
                                    break;
                                case '4':
                                    if (hasZierleistenCounterOpeningSide === false) {
                                        switch (schlagleisteHorizontalGegenBandSeite) {
                                            case '1':
                                            case '2':
                                                lltNumber = 'LLT100077A';
                                                break;
                                        }
                                    } else {
                                        switch (zierleistenArt) {
                                            case '5':
                                            case '6':
                                                switch (schlagleisteHorizontalGegenBandSeite) {
                                                    case '1':
                                                    case '2':
                                                        lltNumber = 'LLT100077A';
                                                        break;
                                                }
                                                break;
                                            case '1':
                                            case '2':
                                                switch (schlagleisteHorizontalGegenBandSeite) {
                                                    case '1':
                                                    case '2':
                                                        lltNumber = 'LLT100078A';
                                                        break;
                                                }
                                                break;
                                            default:
                                                switch (schlagleisteHorizontalGegenBandSeite) {
                                                    case '1':
                                                    case '2':
                                                        lltNumber = 'LLT100078A';
                                                        break;
                                                }
                                                break;
                                        }
                                    }
                                    break;
                            }
                            break;
                    }
                    break;
                case 'LACKIERUNG':
                    switch (doorWings) {
                        case 'D1':
                            if (hasZierleistenCounterOpeningSide === false) {
                                switch (schlagleisteHorizontalGegenBandSeite) {
                                    case '1':
                                        lltNumber = 'LLT100085';
                                        break;
                                    case '2':
                                        lltNumber = 'LLT100086';
                                        break;
                                }
                            } else {
                                switch (zierleistenArt) {
                                    case '5':
                                    case '6':
                                        switch (schlagleisteHorizontalGegenBandSeite) {
                                            case '1':
                                                lltNumber = 'LLT100085';
                                                break;
                                            case '2':
                                                lltNumber = 'LLT100086';
                                                break;
                                        }
                                        break;
                                    case '1':
                                    case '2':
                                        switch (schlagleisteHorizontalGegenBandSeite) {
                                            case '1':
                                                lltNumber = 'LLT100087';
                                                break;
                                            case '2':
                                                lltNumber = 'LLT100088';
                                                break;
                                        }
                                        break;
                                    default:
                                        switch (schlagleisteHorizontalGegenBandSeite) {
                                            case '1':
                                                lltNumber = 'LLT100087';
                                                break;
                                            case '2':
                                                lltNumber = 'LLT100088';
                                                break;
                                        }
                                        break;
                                }
                            }
                            break;
                        case 'D2':
                            switch (resistanceClass) {
                                case '2':
                                case '3':
                                    if (hasZierleistenCounterOpeningSide === false) {
                                        switch (schlagleisteHorizontalGegenBandSeite) {
                                            case '1':
                                            case '2':
                                                lltNumber = 'LLT100079';
                                                break;
                                        }
                                    } else {
                                        switch (zierleistenArt) {
                                            case '5':
                                            case '6':
                                                switch (schlagleisteHorizontalGegenBandSeite) {
                                                    case '1':
                                                    case '2':
                                                        lltNumber = 'LLT100079';
                                                        break;
                                                }
                                                break;
                                            case '1':
                                            case '2':
                                                switch (schlagleisteHorizontalGegenBandSeite) {
                                                    case '1':
                                                    case '2':
                                                        lltNumber = 'LLT100080';
                                                        break;
                                                }
                                                break;
                                            default:
                                                switch (schlagleisteHorizontalGegenBandSeite) {
                                                    case '1':
                                                    case '2':
                                                        lltNumber = 'LLT100080';
                                                        break;
                                                }
                                                break;
                                        }
                                    }
                                    break;
                                case '4':
                                    if (hasZierleistenCounterOpeningSide === false) {
                                        switch (schlagleisteHorizontalGegenBandSeite) {
                                            case '1':
                                            case '2':
                                                lltNumber = 'LLT100079A';
                                                break;
                                        }
                                    } else {
                                        switch (zierleistenArt) {
                                            case '5':
                                            case '6':
                                                switch (schlagleisteHorizontalGegenBandSeite) {
                                                    case '1':
                                                    case '2':
                                                        lltNumber = 'LLT100079A';
                                                        break;
                                                }
                                                break;
                                            case '1':
                                            case '2':
                                                switch (schlagleisteHorizontalGegenBandSeite) {
                                                    case '1':
                                                    case '2':
                                                        lltNumber = 'LLT100080A';
                                                        break;
                                                }
                                                break;
                                            default:
                                                switch (schlagleisteHorizontalGegenBandSeite) {
                                                    case '1':
                                                    case '2':
                                                        lltNumber = 'LLT100080A';
                                                        break;
                                                }
                                                break;
                                        }
                                    }
                                    break;
                            }
                            break;
                    }
                    break;
            }
            break;
    }

    let characteristic: any;
    let value: ValueDefinition;
    const char = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_SCHL_Q_GBS')[0];
    characteristic = copyObject(char);
    value = characteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return value;
};

// KTU_MM_SCHL_S_BS
export const schlagleisteVerticalOpeningSide = (): ValueDefinition => {

    let lltNumber: string = '0';

    const doorLeafSurfaceOpeningSide = helper.GetDependencyValueCode('KTU_MM_TOBERFL_BS', contex.DoorLeafSurface);
    const zierlesitenVariantBandSeite = helper.GetDependencyValueCode('KTU_MM_ZIERLEISTENVAR_BS', contex.Functions);
    const zierleistenArt = helper.GetDependencyValueCode('KTU_MM_ZIERLEISTENART', contex.Functions);
    const schlagleisteVerticalBandSeite = helper.GetDependencyValueCode('KTU_MM_SCHLAGL_ANZ_BS', contex.Functions);

    const hasZierleistenOpeningSide = zierlesitenVariantBandSeite !== 'ZV0' ? true : false;



    if (schlagleisteVerticalBandSeite === '1' || schlagleisteVerticalBandSeite === '2') {
        switch (doorLeafSurfaceOpeningSide) {
            case 'DEKOR':
            case 'FURNIER':
                if (hasZierleistenOpeningSide === false) {
                    lltNumber = 'LLT100070';
                } else {
                    switch (zierleistenArt) {
                        case '5':
                        case '6':
                            lltNumber = 'LLT100070';
                            break;
                        case '1':
                        case '2':
                            lltNumber = 'LLT100072';
                            break;
                        default:
                            lltNumber = 'LLT100072';
                            break;
                    }
                }
                break;
            case 'LACKIERUNG':
                if (hasZierleistenOpeningSide === false) {
                    lltNumber = 'LLT100074';
                } else {
                    switch (zierleistenArt) {
                        case '5':
                        case '6':
                            lltNumber = 'LLT100074';
                            break;
                        case '1':
                        case '2':
                            lltNumber = 'LLT100076';
                            break;
                        default:
                            lltNumber = 'LLT100076';
                            break;
                    }
                }
                break;
        }
    } else {
        lltNumber = '0';
    }

    let characteristic: any;
    let value: ValueDefinition;
    const char = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_SCHL_S_BS')[0];
    characteristic = copyObject(char);
    value = characteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return value;
};

// KTU_MM_SCHL_S_GBS
export const schlagleisteVerticalCounterOpeningSide = (): ValueDefinition => {

    let lltNumber: string = '0';

    const doorLeafSurfaceCounterOpeningSide = helper.GetDependencyValueCode('KTU_MM_TOBERFL_GBS', contex.DoorLeafSurface);
    const zierlesitenVariantGegenBandSeite = helper.GetDependencyValueCode('KTU_MM_ZIERLEISTENVAR_GBS', contex.Functions);
    const zierleistenArt = helper.GetDependencyValueCode('KTU_MM_ZIERLEISTENART', contex.Functions);
    const schlagleisteVerticalGegenBandSeite = helper.GetDependencyValueCode('KTU_MM_SCHLAGL_ANZ_GBS', contex.Functions);

    const hasZierleistenCounterOpeningSide = zierlesitenVariantGegenBandSeite !== 'ZV0' ? true : false;



    if (schlagleisteVerticalGegenBandSeite === '1' || schlagleisteVerticalGegenBandSeite === '2') {
        switch (doorLeafSurfaceCounterOpeningSide) {
            case 'DEKOR':
            case 'FURNIER':
                if (hasZierleistenCounterOpeningSide === false) {
                    lltNumber = 'LLT100069';
                } else {
                    switch (zierleistenArt) {
                        case '5':
                        case '6':
                            lltNumber = 'LLT100070';
                            break;
                        case '1':
                        case '2':
                            lltNumber = 'LLT100071';
                            break;
                        default:
                            lltNumber = 'LLT100072';
                            break;
                    }
                }
                break;
            case 'LACKIERUNG':
                if (hasZierleistenCounterOpeningSide === false) {
                    lltNumber = 'LLT100073';
                } else {
                    switch (zierleistenArt) {
                        case '5':
                        case '6':
                            lltNumber = 'LLT100074';
                            break;
                        case '1':
                        case '2':
                            lltNumber = 'LLT100075';
                            break;
                        default:
                            lltNumber = 'LLT100076';
                            break;
                    }
                }
                break;
        }
    } else {
        lltNumber = '0';
    }

    let characteristic: any;
    let value: ValueDefinition;
    const char = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_SCHL_S_GBS')[0];
    characteristic = copyObject(char);
    value = characteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return value;
};

// KTU_MM_SCHLAG_O_DF_BS
export const schlagleisteHorizontalDFOpeningSide = (): ValueDefinition => {

    let lltNumber: string = '0';

    const doorModel = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);
    const doorLeafSurfaceOpeningSide = helper.GetDependencyValueCode('KTU_MM_TOBERFL_BS', contex.DoorLeafSurface);
    const schlagleisteHorizontalBandSeite = helper.GetDependencyValueCode('CUST_MM_SCHLAGL_ANZ_W_BS', contex.Functions);

    // return values
    const doorLeafSurfaceDekor = helper.GetDependencyValueCode('KTU_MM_TUEROBERFL_BS', contex.DoorLeafSurface);
    const doorLeafSurfaceFurnier = helper.GetDependencyValueCode('KTU_MM_TUEROBERFL_F_BS', contex.DoorLeafSurface);



    switch (schlagleisteHorizontalBandSeite) {
        case '1':
        case '2':
            switch (doorModel) {
                case 'CERT':
                    switch (doorLeafSurfaceOpeningSide) {
                        case 'DEKOR':
                            lltNumber = doorLeafSurfaceDekor;
                            break;
                        case 'FURNIER':
                            lltNumber = doorLeafSurfaceFurnier;
                            break;
                        case 'LACKIERUNG':
                            lltNumber = '0';
                            break;
                    }
                    break;
                case 'BERT':
                case 'VERT':
                    switch (doorLeafSurfaceOpeningSide) {
                        case 'DEKOR':
                            lltNumber = doorLeafSurfaceDekor;
                            break;
                        case 'FURNIER':
                            lltNumber = doorLeafSurfaceFurnier;
                            break;
                        case 'LACKIERUNG':
                            lltNumber = '0';
                            break;
                    }
                    break;
            }
            break;
        default:
            lltNumber = '0';
            break;
    }

    let characteristic: any;
    let value: ValueDefinition;
    const char = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_SCHLAG_O_DF_BS')[0];
    characteristic = copyObject(char);
    value = characteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return value;
};

// KTU_MM_SCHLAG_O_DF_GBS
export const schlagleisteHorizontalDFCounterOpeningSide = (): ValueDefinition => {

    let lltNumber: string = '0';

    const doorModel = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);
    const doorLeafSurface = helper.GetDependencyValueCode('KTU_MM_TOBERFL_GBS', contex.DoorLeafSurface);
    const schlagleisteHorizontal = helper.GetDependencyValueCode('CUST_MM_SCHLAGL_ANZ_W_GBS', contex.Functions);

    // return values
    const doorLeafSurfaceDekor = helper.GetDependencyValueCode('KTU_MM_TUEROBERFL_GBS', contex.DoorLeafSurface);
    const doorLeafSurfaceFurnier = helper.GetDependencyValueCode('KTU_MM_TUEROBERFL_F_GBS', contex.DoorLeafSurface);



    switch (schlagleisteHorizontal) {
        case '1':
        case '2':
            switch (doorModel) {
                case 'CERT':
                    switch (doorLeafSurface) {
                        case 'DEKOR':
                            lltNumber = doorLeafSurfaceDekor;
                            break;
                        case 'FURNIER':
                            lltNumber = doorLeafSurfaceFurnier;
                            break;
                        case 'LACKIERUNG':
                            lltNumber = '0';
                            break;
                    }
                    break;
                case 'BERT':
                case 'VERT':
                    switch (doorLeafSurface) {
                        case 'DEKOR':
                            lltNumber = doorLeafSurfaceDekor;
                            break;
                        case 'FURNIER':
                            lltNumber = doorLeafSurfaceFurnier;
                            break;
                        case 'LACKIERUNG':
                            lltNumber = '0';
                            break;
                    }
                    break;
            }
            break;
        default:
            lltNumber = '0';
            break;
    }

    let characteristic: any;
    let value: ValueDefinition;
    const char = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_SCHLAG_O_DF_GBS')[0];
    characteristic = copyObject(char);
    value = characteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return value;
};

// KTU_MM_SCHLAG_O_L_BS
export const schlagleisteHorizontalLOpeningSide = (): ValueDefinition => {

    let lltNumber: string = '0';

    const doorModel = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);
    const doorLeafSurface = helper.GetDependencyValueCode('KTU_MM_TOBERFL_BS', contex.DoorLeafSurface);
    const schlagleisteHorizontal = helper.GetDependencyValueCode('CUST_MM_SCHLAGL_ANZ_W_BS', contex.Functions);

    // return values
    const doorLeafSurfaceLackierung = helper.GetDependencyValueCode('KTU_MM_TUEROBERFL_L_BS', contex.DoorLeafSurface);



    switch (schlagleisteHorizontal) {
        case '1':
        case '2':
            switch (doorModel) {
                case 'CERT':
                    switch (doorLeafSurface) {
                        case 'DEKOR':
                            lltNumber = '0';
                            break;
                        case 'FURNIER':
                            lltNumber = '0';
                            break;
                        case 'LACKIERUNG':
                            lltNumber = doorLeafSurfaceLackierung;
                            break;
                    }
                    break;
                case 'BERT':
                case 'VERT':
                    switch (doorLeafSurface) {
                        case 'DEKOR':
                            lltNumber = '0';
                            break;
                        case 'FURNIER':
                            lltNumber = '0';
                            break;
                        case 'LACKIERUNG':
                            lltNumber = doorLeafSurfaceLackierung;
                            break;
                    }
                    break;
            }
            break;
        default:
            lltNumber = '0';
            break;
    }

    let characteristic: any;
    let value: ValueDefinition;
    const char = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_SCHLAG_O_L_BS')[0];
    characteristic = copyObject(char);
    value = characteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return value;
};

// KTU_MM_SCHLAG_O_L_GBS
export const schlagleisteHorizontalLCounterOpeningSide = (): ValueDefinition => {

    let lltNumber: string = '0';

    const doorModel = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);
    const doorLeafSurface = helper.GetDependencyValueCode('KTU_MM_TOBERFL_GBS', contex.DoorLeafSurface);
    const schlagleisteHorizontal = helper.GetDependencyValueCode('CUST_MM_SCHLAGL_ANZ_W_GBS', contex.Functions);

    // return values
    const doorLeafSurfaceLackierung = helper.GetDependencyValueCode('KTU_MM_TUEROBERFL_L_GBS', contex.DoorLeafSurface);



    switch (schlagleisteHorizontal) {
        case '1':
        case '2':
            switch (doorModel) {
                case 'CERT':
                    switch (doorLeafSurface) {
                        case 'DEKOR':
                            lltNumber = '0';
                            break;
                        case 'FURNIER':
                            lltNumber = '0';
                            break;
                        case 'LACKIERUNG':
                            lltNumber = doorLeafSurfaceLackierung;
                            break;
                    }
                    break;
                case 'BERT':
                case 'VERT':
                    switch (doorLeafSurface) {
                        case 'DEKOR':
                            lltNumber = '0';
                            break;
                        case 'FURNIER':
                            lltNumber = '0';
                            break;
                        case 'LACKIERUNG':
                            lltNumber = doorLeafSurfaceLackierung;
                            break;
                    }
                    break;
            }
            break;
        default:
            lltNumber = '0';
            break;
    }

    let characteristic: any;
    let value: ValueDefinition;
    const char = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_SCHLAG_O_L_GBS')[0];
    characteristic = copyObject(char);
    value = characteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return value;
};

// KTU_MM_SCHLAG_O_SO_BS
export const schlagleisteSpecialHorizontalOpeningSide = (): ValueDefinition => {

    let valueObject: ValueDefinition = helper.defaultValueObject;

    const doorModel = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);
    const doorLeafSurface = helper.GetDependencyValueCode('KTU_MM_TOBERFL_BS', contex.DoorLeafSurface);
    const schlagleisteHorizontal = helper.GetDependencyValueCode('CUST_MM_SCHLAGL_ANZ_W_BS', contex.Functions);

    // return values
    const doorLeafSurfaceSpecialValue = helper.GetDependencyValueCodeObject('KTU_MM_TUEROBERFL_SO_BS', contex.DoorLeafSurface);



    switch (schlagleisteHorizontal) {
        case '1':
        case '2':
            switch (doorModel) {
                case 'CERT':
                case 'BERT':
                case 'VERT':
                    switch (doorLeafSurface) {
                        case 'DEKOR':
                        case 'FURNIER':
                        case 'LACKIERUNG':
                            valueObject = doorLeafSurfaceSpecialValue;
                            break;
                    }
                    break;
            }
            break;
        default:
            valueObject = helper.defaultValueObject;
            break;
    }

    return valueObject;
};

// KTU_MM_SCHLAG_O_SO_GBS
export const schlagleisteSpecialHorizontalCounterOpeningSide = (): ValueDefinition => {

    let valueObject: ValueDefinition = helper.defaultValueObject;

    const doorModel = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);
    const doorLeafSurface = helper.GetDependencyValueCode('KTU_MM_TOBERFL_GBS', contex.DoorLeafSurface);
    const schlagleisteHorizontal = helper.GetDependencyValueCode('CUST_MM_SCHLAGL_ANZ_W_GBS', contex.Functions);

    // return values
    const doorLeafSurfaceSpecialValue = helper.GetDependencyValueCodeObject('KTU_MM_TUEROBERFL_SO_GBS', contex.DoorLeafSurface);



    switch (schlagleisteHorizontal) {
        case '1':
        case '2':
            switch (doorModel) {
                case 'CERT':
                case 'BERT':
                case 'VERT':
                    switch (doorLeafSurface) {
                        case 'DEKOR':
                        case 'FURNIER':
                        case 'LACKIERUNG':
                            valueObject = doorLeafSurfaceSpecialValue;
                            break;
                    }
                    break;
            }
            break;
        default:
            valueObject = helper.defaultValueObject;
            break;
    }

    return valueObject;
};

// KTU_MM_SCHLAG_S_DF_BS
export const schlagleisteVerticalDFOpeningSide = (): ValueDefinition => {

    let lltNumber: string = '0';

    const schlagleisteHorizontal = helper.GetDependencyValueCode('KTU_MM_SCHLAGL_ANZ_BS', contex.Functions);
    const doorLeafSurface = helper.GetDependencyValueCode('KTU_MM_TOBERFL_BS', contex.DoorLeafSurface);

    // return values
    const doorLeafSurfaceDekor = helper.GetDependencyValueCode('KTU_MM_TUEROBERFL_BS', contex.DoorLeafSurface);
    const doorLeafSurfaceFurnier = helper.GetDependencyValueCode('KTU_MM_TUEROBERFL_F_BS', contex.DoorLeafSurface);



    switch (schlagleisteHorizontal) {
        case '1':
        case '2':
            switch (doorLeafSurface) {
                case 'DEKOR':
                    lltNumber = doorLeafSurfaceDekor;
                    break;
                case 'FURNIER':
                    lltNumber = doorLeafSurfaceFurnier;
                    break;
                case 'LACKIERUNG':
                    lltNumber = '0';
                    break;
            }
            break;
        default:
            lltNumber = '0';
            break;
    }

    let characteristic: any;
    let value: ValueDefinition;
    const char = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_SCHLAG_S_DF_BS')[0];
    characteristic = copyObject(char);
    value = characteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return value;
};

// KTU_MM_SCHLAG_S_DF_GBS
export const schlagleisteVerticalDFCounterOpeningSide = (): ValueDefinition => {

    let lltNumber: string = '0';

    const schlagleisteHorizontal = helper.GetDependencyValueCode('KTU_MM_SCHLAGL_ANZ_GBS', contex.Functions);
    const doorLeafSurface = helper.GetDependencyValueCode('KTU_MM_TOBERFL_GBS', contex.DoorLeafSurface);

    // return values
    const doorLeafSurfaceDekor = helper.GetDependencyValueCode('KTU_MM_TUEROBERFL_GBS', contex.DoorLeafSurface);
    const doorLeafSurfaceFurnier = helper.GetDependencyValueCode('KTU_MM_TUEROBERFL_F_GBS', contex.DoorLeafSurface);


    switch (schlagleisteHorizontal) {
        case '1':
        case '2':
            switch (doorLeafSurface) {
                case 'DEKOR':
                    lltNumber = doorLeafSurfaceDekor;
                    break;
                case 'FURNIER':
                    lltNumber = doorLeafSurfaceFurnier;
                    break;
                case 'LACKIERUNG':
                    lltNumber = '0';
                    break;
            }
            break;
        default:
            lltNumber = '0';
            break;
    }

    let characteristic: any;
    let value: ValueDefinition;
    const char = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_SCHLAG_S_DF_GBS')[0];
    characteristic = copyObject(char);
    value = characteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return value;
};

// KTU_MM_SCHLAG_S_L_BS
export const schlagleisteVerticalLOpeningSide = (): ValueDefinition => {

    let lltNumber: string = '0';

    const schlagleisteHorizontal = helper.GetDependencyValueCode('KTU_MM_SCHLAGL_ANZ_BS', contex.Functions);
    const doorLeafSurface = helper.GetDependencyValueCode('KTU_MM_TOBERFL_BS', contex.DoorLeafSurface);

    // return values
    const doorLeafSurfaceLackierung = helper.GetDependencyValueCode('KTU_MM_TUEROBERFL_L_BS', contex.DoorLeafSurface);



    switch (schlagleisteHorizontal) {
        case '1':
        case '2':
            switch (doorLeafSurface) {
                case 'DEKOR':
                case 'FURNIER':
                    lltNumber = '0';
                    break;
                case 'LACKIERUNG':
                    lltNumber = doorLeafSurfaceLackierung;
                    break;
            }
            break;
        default:
            lltNumber = '0';
            break;
    }

    let characteristic: any;
    let value: ValueDefinition;
    const char = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_SCHLAG_S_L_BS')[0];
    characteristic = copyObject(char);
    value = characteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return value;
};

// KTU_MM_SCHLAG_S_L_GBS
export const schlagleisteVerticalLCounterOpeningSide = (): ValueDefinition => {

    let lltNumber: string = '0';

    const schlagleisteHorizontal = helper.GetDependencyValueCode('KTU_MM_SCHLAGL_ANZ_GBS', contex.Functions);
    const doorLeafSurface = helper.GetDependencyValueCode('KTU_MM_TOBERFL_GBS', contex.DoorLeafSurface);

    // return values
    const doorLeafSurfaceLackierung = helper.GetDependencyValueCode('KTU_MM_TUEROBERFL_L_GBS', contex.DoorLeafSurface);



    switch (schlagleisteHorizontal) {
        case '1':
        case '2':
            switch (doorLeafSurface) {
                case 'DEKOR':
                case 'FURNIER':
                    lltNumber = '0';
                    break;
                case 'LACKIERUNG':
                    lltNumber = doorLeafSurfaceLackierung;
                    break;
            }
            break;
        default:
            lltNumber = '0';
            break;
    }

    let characteristic: any;
    let value: ValueDefinition;
    const char = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_SCHLAG_S_L_GBS')[0];
    characteristic = copyObject(char);
    value = characteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return value;
};

// KTU_MM_SCHLAG_S_SO_BS
export const schlagleisteSpecialVerticalOpeningSide = (): ValueDefinition => {

    let valueObject: ValueDefinition = helper.defaultValueObject;

    const doorLeafSurface = helper.GetDependencyValueCode('KTU_MM_TOBERFL_BS', contex.DoorLeafSurface);
    const schlagleisteVertical = helper.GetDependencyValueCode('KTU_MM_SCHLAGL_ANZ_BS', contex.Functions);

    // return values
    const doorLeafSurfaceSpecialValue = helper.GetDependencyValueCodeObject('KTU_MM_TUEROBERFL_SO_BS', contex.DoorLeafSurface);



    switch (schlagleisteVertical) {
        case '1':
        case '2':
            switch (doorLeafSurface) {
                case 'DEKOR':
                case 'FURNIER':
                case 'LACKIERUNG':
                    valueObject = doorLeafSurfaceSpecialValue;
                    break;
            }
            break;
        default:
            valueObject = helper.defaultValueObject;
            break;
    }

    return valueObject;
};

// KTU_MM_SCHLAG_S_SO_GBS
export const schlagleisteSpecialVerticalCounterOpeningSide = (): ValueDefinition => {

    let valueObject: ValueDefinition = helper.defaultValueObject;

    const doorLeafSurface = helper.GetDependencyValueCode('KTU_MM_TOBERFL_GBS', contex.DoorLeafSurface);
    const schlagleisteVertical = helper.GetDependencyValueCode('KTU_MM_SCHLAGL_ANZ_GBS', contex.Functions);

    // return values
    const doorLeafSurfaceSpecialValue = helper.GetDependencyValueCodeObject('KTU_MM_TUEROBERFL_SO_GBS', contex.DoorLeafSurface);



    switch (schlagleisteVertical) {
        case '1':
        case '2':
            switch (doorLeafSurface) {
                case 'DEKOR':
                case 'FURNIER':
                case 'LACKIERUNG':
                    valueObject = doorLeafSurfaceSpecialValue;
                    break;
            }
            break;
        default:
            valueObject = helper.defaultValueObject;
            break;
    }

    return valueObject;
};